import { FormattedMessage } from 'react-intl';

export const CompanyInfoHeader = () => {
    return (
        <h2 className={'text-center margin-bottom-20'}>
            <FormattedMessage id={'registration.companyData.heading'} />
        </h2>
    );
};
